import { render } from "./OrganizerList.vue?vue&type=template&id=47af0bbe&scoped=true"
import script from "./OrganizerList.vue?vue&type=script&lang=js"
export * from "./OrganizerList.vue?vue&type=script&lang=js"

import "./OrganizerList.vue?vue&type=style&index=0&id=47af0bbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47af0bbe"]])

export default __exports__